<app-page-title title="Setor"></app-page-title>
<div class="form-container">
  <form [formGroup]="form">
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Nome</mat-label>
      <input class="input" matInput placeholder="Nome" formControlName="name" name="description" />
      <mat-error *ngIf="form.controls.name.hasError('required')"> Obrigatório </mat-error>
    </mat-form-field>
    <br />
    <!--
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Líder</mat-label>
      <mat-select formControlName="leader_id">
        <mat-option *ngFor="let member of members" [value]="member.id">
          {{ member.name }}
        </mat-option>
      </mat-select>


      <mat-error *ngIf="form.controls.leader_id.hasError('required')"> Obrigatório </mat-error>
    </mat-form-field>
    <br /> -->

    <mat-form-field class="example-full-width" appearance="outline" id="home_number" *ngIf="!leader?.name">
      <mat-label>Lider - CECID</mat-label>
      <input matInput placeholder="Discipulador" formControlName="leader_id" #cecid />
      <button mat-icon-button matSuffix (click)="findByCECID(cecid.value)">
        <mat-icon>search</mat-icon>
      </button>
      <mat-error> Obrigatorio </mat-error>
    </mat-form-field>

    <br />
    <mat-form-field class="example-full-width" appearance="outline" id="name" *ngIf="leader?.name">
      <mat-label>Discipulador</mat-label>
      <input matInput placeholder="Nome" [value]="leader?.name" disabled />
      <button mat-icon-button matSuffix (click)="clearLeader()" *ngIf="leader?.name">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Area</mat-label>
      <mat-select formControlName="area_id">
        <mat-option *ngFor="let area of areas" [value]="area.id">
          {{ area.description }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.controls.area_id.hasError('required')"> Obrigatório </mat-error>
    </mat-form-field>

    <br />
    <button *ngIf="!id" (click)="add()" mat-raised-button class="btn-primary">Cadastrar</button>

    <button *ngIf="id" (click)="save()" class="btn-primary" mat-raised-button>Salvar</button>
  </form>
</div>
